import cx from 'classnames';
import React from 'react';
export const FormLayout = ({ children, className, indentation, layout, ...rest }) => (React.createElement("div", { className: cx('tds-form-layout', {
        [`tds-form-layout--${layout}`]: layout,
        [`tds-form--${indentation}`]: indentation,
    }, className), ...rest }, children));
